import { render } from "./AnalyzeSoilConsulting.vue?vue&type=template&id=63841794"
import script from "./AnalyzeSoilConsulting.vue?vue&type=script&lang=js"
export * from "./AnalyzeSoilConsulting.vue?vue&type=script&lang=js"

import "./AnalyzeSoilConsulting.vue?vue&type=style&index=0&id=63841794&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__